/* eslint-disable vue/valid-v-for */
<template>
  <v-navigation-drawer v-model="$store.state.layout.drawer" clipped app width="272" class="app-navigation">
    <div class="navigation-meta"><span>Workspace</span><span class="navigation-version">v{{ version }}</span></div>
    <v-list dense nav class="navigation-list">
      <template v-for="item in items">
        <div v-if="item.header" :key="item.header" class="navigation-section-label">{{ item.header }}</div>
        <v-list-group
          v-else-if="item.children"
          :key="item.title"
          v-model="item.model"
          :prepend-icon="item.icon"
          class="navigation-group"
        >
          <template v-slot:activator>
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </template>
          <v-list-item
            :to="child.path"
            class="navigation-child"
            @click="child.click && child.click()"
            v-for="(child, i) in item.children"
            :key="i"
            link
          >
            <v-list-item-icon v-if="child.icon"><v-icon size="19">{{ child.icon }}</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ child.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-divider :key="item.name" v-else-if="item.divider" class="navigation-divider" />
        <v-list-item
          v-else
          :key="item.title"
          link
          :to="item.path"
          :exact="item.path === '/'"
          class="navigation-item"
          @click="item.click && item.click()"
        >
          <v-list-item-icon><v-icon size="21">{{ item.icon }}</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import dashbaordService from "../../Home/service";
// import inventoryService from "../../Inventory/service";
// const ImeiSearch = () => import("@/components/ImeiSearch");
// const RestockSerial = () => import("@/components/RestockSerial");
const pjson = require("../../../../package.json");
// import navService from "../service";
// import sound from "../../../assets/audio/u_have_a_task.mp3";

// const audio = new Audio(sound);

export default {
  data() {
    return {
      items: [],
      mini: false,
      right: null,
      leadsBadge: 0,
      ticketsBadge: 0,
      taskBadge: 0,
      inventoryBadge: 0,
      locationBadge: 0,
    };
  },
  computed: {
    ...mapGetters("integration", ["modules"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    version() {
      return pjson.version;
    },
  },
  async mounted() {
    await this.loadNav();
  },
  methods: {
    ...mapActions("layout", ["setOpenSerialSearch", "setOpenRestockSerial"]),
    loadNav() {
      this.items = [];
      this.items.push({ header: "Menu" });
      this.items.push({
        title: this.$t("sideBar.home"),
        icon: "mdi-home-outline",
        name: "home",
        path: "/",
      });
      this.items.push({ divider: true });
      if (this.checkRightStatus(2)) {
        this.items.push({
          title: "Donors",
          icon: "mdi-hand-coin-outline",
          // "icon-alt": "mdi-hand-coin-outline",
          name: "donors",
          path: "/donors",
          // children: [
          //   {
          //     name: "donorList",
          //     icon: "mdi-hand-coin-outline",
          //     title: "List",
          //     path: "/donors",
          //   },
          //   {
          //     name: "paymentRequest",
          //     icon: "mdi-credit-card-outline",
          //     title: "Payment Request",
          //     path: "/donors/paymentRequest/list",
          //   },
          //   {
          //     title: "Invoice",
          //     icon: "mdi-invoice-list-outline",
          //     name: "invoice",
          //     path: "/invoice",
          //   },

          // ],
        });
        this.items.push({ divider: true });
      }
      if (this.checkRightStatus(6)) {
        this.items.push({
          title: "Parents",
          icon: "mdi-account-circle-outline",
          name: "parents",
          path: "/parents",
        });
      }

      if (this.checkRightStatus(10)) {
        this.items.push({
          title: "Students",
          icon: "mdi-account-school-outline",
          name: "student",
          path: "/students",
        });
      }

      if (this.checkRightStatus(14)) {
        this.items.push({
          title: "Applications",
          icon: "mdi-filter-outline",
          name: "applications",
          path: "/applications",
          // children: [
          //   {
          //     title: "Kids",
          //     icon: "mdi-human-male-board",
          //     name: "Adult",
          //     path: "/applications",
          //   },
          //   {
          //     name: "Adult",
          //     icon: "mdi-shape-plus-outline",
          //     title: "Adult",
          //     path: "/departments",
          //   },
          // ],
        });
      }

      this.items.push({
        title: "Administration",
        icon: "mdi-shield-crown-outline",
        name: "administration",
        children: [
          {
            title: "Teachers",
            icon: "mdi-human-male-board",
            name: "teachers",
            path: "/teachers",
          },
          {
            name: "departments",
            icon: "mdi-shape-plus-outline",
            title: "Departments",
            path: "/departments",
          },
          {
            name: "classRoom",
            icon: "mdi-google-classroom",
            title: "Classrooms",
            path: "/classRoom",
          },
          {
            name: "virtualClassRoom",
            icon: "mdi-book-education-outline",
            title: "Virtual Classrooms",
            path: "/virtualClassRoom",
          },
          {
            title: "Year",
            icon: "mdi-calendar-range",
            name: "year",
            path: "/reportcard/year",
          },
          {
            title: "Terms",
            icon: "mdi-clipboard-text-clock",
            name: "terms",
            path: "/reportcard/terms",
          },
          {
            title: "Subjects",
            icon: "mdi-book-multiple",
            name: "subject",
            path: "/reportcard/subject",
          },
          {
            title: "Curriculums",
            icon: "mdi-bookshelf",
            name: "curriculums",
            path: "/reportcard/curriculums",
          },
        ],
      });

      this.items.push({
        title: "Report Card",
        icon: "mdi-card-account-details-outline",
        name: "administration",
        children: [
          {
            title: "Grades",
            icon: "mdi-counter",
            name: "grades",
            path: "/reportcard/grades",
          },

          {
            title: "Term Comments",
            icon: "mdi-comment-text-multiple-outline",
            name: "curriculums",
            path: "/reportcard/termComments",
          },
        ],
      });

      // this.items.push({
      //   title: "Teachers",
      //   icon: "mdi-human-male-board",
      //   name: "teachers",
      //   path: "/teachers",
      // });

      // this.items.push({
      //   name: "classes",
      //   icon: "mdi-google-classroom",
      //   title: "Classes",
      //   path: "/classes",
      // });

      // this.items.push({
      //   name: "classRoom",
      //   icon: "mdi-google-classroom",
      //   title: "Class Rooms",
      //   path: "/classRoom",
      // });

      // this.items.push({
      //   title: "Invoice",
      //   icon: "mdi-cart-outline",
      //   name: "invoice",
      //   path: "/invoice",
      // });

      // this.items.push({
      //   title: "List",
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   name: "inventory",
      //   path: "/inventory",
      //   children: [
      //     {
      //       name: "purchase",
      //       icon: "mdi-package-variant-closed",
      //       title: "Purchase",
      //       path: "/inventory/purchase",
      //     },
      //     {
      //       name: "purchaseOrder",
      //       icon: "mdi-package-variant",
      //       title: "Purchase Order",
      //       path: "/inventory/purchaseOrder",
      //     },
      //     {
      //       title: "Account",
      //       icon: "mdi-cellphone-android",
      //       name: "product",
      //       path: "/product/list",
      //     },
      //     {
      //       name: "vendor",
      //       icon: "mdi-truck-outline",
      //       title: "Vendor",
      //       path: "/inventory/vendor",
      //     },
      //     {
      //       name: "count",
      //       icon: "mdi-counter",
      //       title: "Count",
      //       path: "/inventory/count",
      //     },
      //   ],
      // });

      // this.items.push({
      //   title: "Order",
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   name: "order",
      //   children: [
      //     {
      //       name: "inHouse",
      //       icon: "mdi-office-building",
      //       title: "In House",
      //       path: "/order",
      //     },
      //     {
      //       name: "catalog",
      //       icon: "mdi-book-open-outline",
      //       title: "Catalog",
      //       path: "/catalog/create",
      //     },
      //     {
      //       name: "remote",
      //       icon: "mdi-tablet-cellphone",
      //       title: "Remote",
      //       path: "/RemoteView",
      //     },
      //   ],
      // });

      // this.items.push({
      //   title: "Product",
      //   icon: "mdi-cellphone-android",
      //   name: "product",
      //   path: "/product/list",
      // });
      // this.items.push({
      //   title: "Category",
      //   icon: "mdi-shape",
      //   name: "expense",
      //   path: "/inventory/category/list"
      // });

      // this.items.push({
      //   title: "Expense",
      //   icon: "mdi-wallet-outline",
      //   name: "expense",
      //   path: "/expense",
      // });

      // this.items.push({
      //   title: "TV Adware",
      //   icon: "mdi-chevron-down",
      //   "icon-alt": "mdi-chevron-right",
      //   name: "tvAdware",
      //   children: [
      //     {
      //       title: "Screen",
      //       icon: "mdi-television",
      //       name: "screen",
      //       path: "/tvAdware/screen",
      //     },
      //     {
      //       title: "Ad Image",
      //       icon: "mdi-panorama-variant-outline",
      //       name: "adImage",
      //       path: "/tvAdware/adImage",
      //     },
      //   ]
      // });

      this.items.push({
        title: "Invoice",
        icon: "mdi-invoice-outline",
        name: "invoice",
        children: [
          // {
          //   name: "donorList",
          //   icon: "mdi-hand-coin-outline",
          //   title: "List",
          //   path: "/list",
          // },

          {
            title: "Invoice",
            icon: "mdi-invoice-list-outline",
            name: "invoice",
            path: "/invoice/list",
          },
          {
            title: "Open Invoice",
            icon: "mdi-cart-outline",
            name: "open-invoice",
            path: "/invoice/openInvoice",
          },
          {
            title: "Missing Invoices",
            icon: "mdi-file-document-alert-outline",
            name: "missing-invoices",
            path: "/invoice/missing",
          },
          {
            name: "subscription",
            icon: "mdi-cash-sync",
            title: "Subscription",
            path: "/subscription/list",
          },
          {
            name: "transactions",
            icon: "mdi-credit-card-search-outline",
            title: "Transactions",
            path: "/invoice/transactions",
          },
        ],
      });

      if (this.checkRightStatus(66)) {
        this.items.push({
          title: "Report",
          icon: "mdi-chart-bell-curve",
          name: "report",
          path: "/report/home",
        });
      }

      if (this.checkRightStatus(70)) {
        this.items.push({
          title: "Events",
          icon: "mdi-calendar",
          name: "events",
          path: "/events",
        });
      }

      // this.items.push({
      //   title: "Serial Search",
      //   icon: "mdi-feature-search-outline",
      //   name: "serailSearch",
      //   click: () => {
      //     this.setOpenSerialSearch(true);
      //   },
      // });

      this.items.push({ divider: true });

      // this.items.push({
      //   title: this.$t("sideBar.list"),
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   name: "list",
      //   path: "",
      //   children: [
      //     {
      //       name: "payee",
      //       icon: "mdi-account-check-outline",
      //       title: "Payee",
      //       path: "/expense/payee/list",
      //     },
      //     {
      //       name: "vendor",
      //       icon: "mdi-truck-outline",
      //       title: "Vender",
      //       path: "/inventory/vendor",
      //     },
      //     {
      //       name: "payments",
      //       icon: "mdi-cash-multiple",
      //       title: "Payments",
      //       path: "/customer/payment/home",
      //     },
      //   ],
      // });
      // this.items.push({
      //   title: "Deleted",
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   name: "deleted",
      //   path: "",
      //   children: [
      //     {
      //       name: "deleteCustomer",
      //       icon: "mdi-account-off-outline",
      //       title: "Deleted Customer",
      //       path: "/customer/deleted",
      //     },
      //     {
      //       name: "deletedInvoice",
      //       title: "Deleted Invoice",
      //       icon: "mdi-delete-off-outline",
      //       path: "/invoice/deleted",
      //     },
      //   ],
      // });

      // title: "List",
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   name: "inventory",
      //   path: "/inventory",

      this.items.push({
        title: "Settings",
        icon: "mdi-account-key-outline",
        name: "adminTools",
        path: "/adminTools/home",
        children: [
          {
            title: "Financial Aid",
            icon: "mdi-wallet",
            name: "financialAid",
            path: "/sadqaFinancialAid",
          },

          {
            title: "Campaign",
            icon: "mdi-newspaper-variant-outline",
            name: "campaign",
            path: "/campaign/list",
          },
          {
            title: "Zakat Allocation",
            icon: "mdi-cash-multiple",
            name: "zakatAllocation",
            path: "/zakatAllocation/list",
          },
          {
            title: "Transaction",
            icon: "mdi-bank-transfer",
            name: "transaction",
            path: "/transaction/list",
          },
          ...(this.checkRightStatus(18) ? [{
            title: "Comments",
            icon: "mdi-comment-outline",
            name: "comments",
            path: "/comment",
          }] : []),
          // {
          //   title: "Donation Category",
          //   icon: "mdi-hand-coin-outline",
          //   name: "donationCategory",
          //   path: "/donationCategory/list",
          // },
          {
            title: "Settings",
            icon: "mdi-cogs",
            name: "adminTools",
            path: "/adminTools/home",
          },
        ],
      });

      // this.items.push({
      //   title: this.$t("sideBar.adminTools"),
      //   group: "",
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   children: [
      //     {
      //       name: "user",
      //       icon: "mdi-shield-account-outline",
      //       title: this.$t("sideBar.user"),
      //       path: "/user",
      //     },
      //     {
      //       name: "restock",
      //       icon: "mdi-barcode-scan",
      //       title: "Restock Serial",
      //       click: () => {
      //         this.setOpenRestockSerial(true);
      //       },
      //     },
      //     {
      //       name: "setting",
      //       icon: "mdi-cog-outline",
      //       title: "Setting",
      //       path: "/setting",
      //     },
      //   ],
      // });
    },
  },
};
</script>

<style scoped>
.app-navigation { border-right: 1px solid #e4e9e4 !important; background: #fbfcfb !important; }
.navigation-meta { display: flex; align-items: center; justify-content: space-between; padding: 15px 18px 8px; color: #839087; font-size: 10px; font-weight: 750; letter-spacing: .08em; text-transform: uppercase; }
.navigation-version { padding: 3px 7px; border-radius: 6px; color: #667269; background: #f0f3f0; font-size: 9px; letter-spacing: .03em; text-transform: none; }
.navigation-list { padding: 0 10px 14px !important; }
.navigation-section-label { padding: 8px 10px 6px; color: #9aa49c; font-size: 9px; font-weight: 800; letter-spacing: .1em; text-transform: uppercase; }

.navigation-item,
.navigation-group ::v-deep > .v-list-group__header,
.navigation-child { min-height: 43px; margin: 2px 0; border-radius: 9px !important; color: #465149; }

.navigation-list ::v-deep .v-list-item__icon { align-self: center; min-width: 28px; margin: 0 12px 0 0 !important; color: #758078; }
.navigation-list ::v-deep .v-list-item__title { font-size: 12px; font-weight: 600; line-height: 1.3; }
.navigation-list ::v-deep .v-list-item--active { color: #2e7d32 !important; background: #eaf5eb !important; }
.navigation-list ::v-deep .v-list-item--active::before { opacity: 0 !important; }
.navigation-list ::v-deep .v-list-item--active .v-icon { color: #43a047 !important; }
.navigation-list ::v-deep .v-list-item:hover { background: #f1f5f1; }

.navigation-group ::v-deep .v-list-group__header__append-icon { min-width: 22px; margin: 0 !important; }
.navigation-group ::v-deep .v-list-group__header__append-icon .v-icon { color: #8b958d; font-size: 18px; }
.navigation-group ::v-deep .v-list-group__items { position: relative; margin: 2px 0 7px 20px; padding-left: 12px; border-left: 1px solid #dfe7df; }
.navigation-child { padding-left: 10px !important; }
.navigation-child ::v-deep .v-list-item__icon { min-width: 24px; margin-right: 8px !important; }
.navigation-child ::v-deep .v-list-item__title { font-size: 11px; }
.navigation-divider { margin: 8px !important; border-color: #e8ece8 !important; }

</style>
